<template>
  <v-btn
    flat
    class="text-secondary"
    @click="reset()"
  >
    {{ $t('Signup.Title') }}
  </v-btn>
  <SimpleCardDialog
    v-model:dialog="dialog"
    max-width="500"
    :title="$t('Signup.Title')"
  >
    <!-- content -->
    <template v-if="isSubmit===false">
      <p>{{ $t('Signup.PreSignupMessage') }}</p>

      <TermsLink
        color="grey"
        class="mb-3"
      />

      <TextInput
        v-model="formData.email"
        field-key="email"
        :label="$t('User.EmailAddress')"
        required
        type="email"
      />
    </template>
    <template v-else>
      <div class="mb-3">
        {{ $t('Signup.PreSignupSubmitMessage', {email: formData.email}) }}
      </div>
    </template>

    <template #actions>
      <template v-if="isSubmit===false">
        <ActionButton
          cancel
          @click="close()"
        />
        <ActionButton
          submit
          @click="submit()"
        />
      </template>

      <template v-else>
        <ActionButton
          close
          @click="close()"
        />
      </template>
    </template>
  </SimpleCardDialog>
</template>

<script>
import http from '../../library/no_session_http'
import settings from '../../settings'
import { mapGetters } from 'vuex'
import ActionButton from '../../components/parts/button/ActionButton'
import SimpleCardDialog from '../../components/parts/dialog/SimpleCardDialog'
import TextInput from '../../components/parts/inputs/TextInput'
import TermsLink from '../../terms/TermsLink'

export default {
  components: { TermsLink, TextInput, SimpleCardDialog, ActionButton },
  data: () => ({
    dialog: false,
    formData: {
      email: ''
    },
    isSubmit: false
  }),
  computed: {
    ...mapGetters(['errorRes', 'ui'])
  },
  methods: {
    reset () {
      this.$store.dispatch('clearErrorRes')
      this.formData = {
        email: ''
      }
      this.isSubmit = false
      this.dialog = true
    },
    submit () {
      this.formData.language = this.$i18n.locale
      http.post(settings.ApiUrl + 'pre-signup/', this.formData).then(
        (res) => {
          this.isSubmit = true
        }
      )
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.isSubmit = false
      }, 500)
    }
  }
}
</script>

<style scoped>

</style>
